// import request from "@/config/utils/request";
import { addUrlPerFix } from "@/utils";
import axios from "axios";

export function payRecordTemplate(data) {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().post(
    baseURL + "/apis/emc/batch/templateDownload/batchSubmitTemplate",
    {
      agentId: 100108,
      ...data
    },
    {
      responseType: "blob"
    }
  );
}
